import React, {Component} from 'react';
import {
    Dimensions,
    Image,
    View,
    I18nManager,
    StatusBar,
    Text,
    StyleSheet,
    AppState,
    TouchableOpacity, Modal, TextInput, TouchableWithoutFeedback, Alert, Platform
} from 'react-native';
import {connect} from "react-redux";

import HttpRequest from "../utils/HttpRequest";
import AppButton from "./AppButton";
import AppText from "./AppText";
import ISubOrder from "../Models/Courier/ISubOrder";
import IOrder from "../Models/IOrder";
import {EOrderStatus} from "../Models/EOrderStatus";
import IAppState from "../Models/App/IAppState";
import {saveOpenedOrders} from "../Models/Courier/CourierActions";
import {AnyAction} from "redux";
import DateTimePicker from "@react-native-community/datetimepicker";
import IClient from "../Models/Client/IClient";
import HideableView from "./HideableView";


interface IProps {
    show:boolean;
    closeCallBack:Function;
    client?:IClient
}
interface IState {
    from:Date,
    to:Date,
    loading:boolean,
    status:string;
    isError:boolean;
    showFromDate:boolean;
    showToDate:boolean;
}
export default class PrintClientOrdersModal extends Component< IProps > {
    state:IState={
        from:new Date(),
        to:new Date(),
        loading:false,
        status:'',
        isError:false,
        showFromDate:false,
        showToDate:false
    }
    componentDidMount(): void {

    }
    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any) {
        if(this.props.client != prevProps.client){
            this.setState({from:new Date(),
                to:new Date(),
                loading:false,
                status:'',
                isError:false,showToDate:false,showFromDate:false})
        }
    }

    print(){
        this.setState({loading:true,status:'',isError:false})
        if(!this.props.client) return
        HttpRequest('orders/printOrders','POST',{fromDate:this.state.from,toDate:this.state.to,clientId:this.props.client.id}).then((result)=>{
            if(result.status==200){
                this.setState({status:'פעולה בוצעה בהצלחה והקובץ נשלח למייל שלך',isError:false})
                return
            }
            this.setState({status:'שגיאת רשת אנא נסה שוב',isError:true})
        }).catch(e=>{
            if(e.hasOwnProperty("status") && e.status && e.status==401){
                this.setState({status:'אין הזמנות בתאריך זה',isError:true})
                return;
            }
            this.setState({status:'שגיאת רשת אנא נסה שוב',isError:true})
        }).finally(()=>this.setState({loading:false}))
    }
    render() {
        return(
            <Modal
                animationType="fade"
                transparent={true }
                visible={ this.props.show ? true : false}

                onRequestClose={() => {

                }}
            >
                <View style={{width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,0.5)',justifyContent:'center',alignItems:'center'}}>
                    <View style={{width:'90%',backgroundColor:'white',paddingLeft:5,paddingRight:5,alignItems:'flex-start'}}>
                       <TouchableOpacity onPress={()=>this.props.closeCallBack()}>
                           <AppText style={{fontSize:22,color:'black'}}>X</AppText>
                       </TouchableOpacity>
                        <AppText style={{fontSize:15,fontWeight:'500'}}>{"מתאריך: "+this.state.from.toDateString()}</AppText>
                        <HideableView hidden={Platform.OS=='ios'}>
                            <TouchableOpacity onPress={()=>this.setState({showFromDate:true})} style={{width:100,height:35,marginTop:10,marginBottom:10,justifyContent:'center',alignItems:'center',backgroundColor:'#888888',borderRadius:5,marginLeft:30}}>
                                <AppText style={{color:'#fff',fontWeight:'700'}}>בחר תאריך</AppText>
                            </TouchableOpacity>
                        </HideableView>
                        <HideableView hidden={Platform.OS=='android'&&!this.state.showFromDate} style={{width:'100%'}}>

                             <DateTimePicker
                                testID="dateTimePicker"
                                value={this.state.from}

                                is24Hour={true}
                                display="spinner"
                                onChange={(event, selectedDate) =>{
                                    this.setState({from:selectedDate,showFromDate:false})
                                }}
                                mode={"date"}
                            />
                        </HideableView>
                        <AppText style={{fontSize:15,fontWeight:'500'}}>{"מתאריך: "+this.state.to.toDateString()}</AppText>
                        <HideableView hidden={Platform.OS=='ios'}>
                            <TouchableOpacity onPress={()=>this.setState({showToDate:true})} style={{width:100,height:35,marginTop:10,marginBottom:10,justifyContent:'center',alignItems:'center',backgroundColor:'#888888',borderRadius:5,marginLeft:30}}>
                                <AppText style={{color:'#fff',fontWeight:'700'}}>בחר תאריך</AppText>
                            </TouchableOpacity>
                        </HideableView>
                        <HideableView hidden={Platform.OS=='android'&&!this.state.showToDate} style={{width:'100%'}}>
                            <DateTimePicker
                                testID="dateTimePicker"
                                value={this.state.to}

                                is24Hour={true}
                                display="spinner"
                                onChange={(event, selectedDate) =>{
                                    this.setState({to:selectedDate,showToDate:false})
                                }}
                                mode={"date"}
                            />
                        </HideableView>
                        <View style={{width:'100%',justifyContent:'center',alignItems:'center',marginBottom:5,marginTop:5}}>
                            <AppText style={{fontSize:16,fontWeight:'500',color:this.state.isError?'red':'black'}}>{this.state.status}</AppText>
                        </View>

                        <View style={{width:'100%',justifyContent:'center',alignItems:'center',marginBottom:15}}>
                            <AppButton width={120} text={'הדפס'} onPress={()=>this.print()} isLoading={this.state.loading}/>
                        </View>

                    </View>
                </View>


            </Modal>
        )
    }
}

